<template lang="pug">
.usage
  .container
    h2 便捷的使用方式
    ul
      li 灵活的调度比例配置
      li 部署秒级生效
      li 多域名统一维护、管理
      li 服务状况一目了然
</template>

<script>
export default {
  name: 'usage'
}
</script>

<style lang="sass" scoped>
.usage
  padding: 90px 0
  background-image: url('../assets/usage.png')
  background-position: center
  color: #ffffff

.container
  margin-left: 53%

ul
  margin: 43px 0 0 1.5em

li
  margin-top: 20px
  font-size: 18px
</style>



// WEBPACK FOOTER //
// usage.vue?29e59c7c